<template>
  <main class="login">
    <section>
      <div class="branding">
        <figure class="logo" alt="PTC Wizard Logo">
          <Logo />
        </figure>
        <div class="school-name">School Name</div>
      </div>
      <div class="card">
        <form
          class="needs-validation"
          :class="[wasValidated ? 'was-validated' : null]"
          @click.prevent="save"
        >
          <h4 class="card-header">Reset Password</h4>
          <div class="card-body">
            <p class="text-start">
              <span v-t="'message.Login.password_reset'"></span>
              <br/>
              <span class="warning" v-t="'message.Login.password_reset_warning'"></span>
            </p>
            <div class="vstack gap-2 mb-4" v-if="!passwordReset">
              <div class="form-floating input-group input-group-end">
                <input
                  :type="[cleartextPass1 ? 'text' : 'password']"
                  class="form-control form-control-lg"
                  id="password2"
                  placeholder="Choose New Password"
                  @click="clearForm()"
                  required
                  v-model="password"
                />
                <label for="password2"><span v-t="'message.Login.password_update'"></span></label>
                <button
                  class="btn btn-lg"
                  @click="cleartextPass1 = !cleartextPass1"
                  :title="[cleartextPass1 ? 'Hide Password' : 'Show Password']"
                >
                  <i
                    class="bi text-primary"
                    :class="[cleartextPass1 ? 'bi-eye-slash-fill' : 'bi-eye-fill']"
                  ></i>
                </button>
                <div class="invalid-tooltip">Validation Error Message</div>
              </div>

              <div class="form-floating input-group input-group-end">
                <input
                  :type="[cleartextPass2 ? 'text' : 'password']"
                  class="form-control form-control-lg"
                  id="password2"
                  placeholder="Confirm New Password"
                  @focusin="clearForm()"
                  required
                  v-model="password_confirm"
                />
                <label for="password2"><span v-t="'message.Login.password_update_confirm'"></span></label>
                <button
                  class="btn btn-lg"
                  @click="cleartextPass2 = !cleartextPass2"
                  :title="[cleartextPass2 ? 'Hide Password' : 'Show Password']"
                >
                  <i
                    class="bi text-primary"
                    :class="[cleartextPass2 ? 'bi-eye-slash-fill' : 'bi-eye-fill']"
                  ></i>
                </button>
                <div class="invalid-tooltip">Validation Error Message</div>
              </div>
            </div>

            <button
              class="submit"
              @click="loadingState = !loadingState"
              :disabled="loadingState"
              v-if="!passwordReset"
            >
              <span>Change password</span>
            </button>
            <div class="alert alert-danger px-5 mt-2" v-if="passwordError">
              {{ errorMsg }}
            </div>
            <div class="alert alert-success px-5 mt-2" v-if="passwordReset">
              <span v-t="'message.Login.password_update_success'"></span><br />
              <router-link
                :to="{
                  name: 'parent-login',
                  params: { account: $route.params.account }
                }"
                ><span v-t="'message.Login.return_to_sign_in'"></span></router-link
              >
            </div>
          </div>
          <div class="card-footer">
            <router-link
              class="btn btn-link"
              :to="{
                name: 'parent-login',
                params: { account: $route.params.account }
              }"
            >
              <i class="bi bi-arrow-left me-2 opacity-50"></i><span>Return to Sign In</span>
            </router-link>
          </div>
        </form>
      </div>
      <small class="text-muted vstack gap-1">
        <strong class="opacity-50">Parent Teacher Conference Scheduling Made Easy</strong>
        <div>&copy;2006 - {{ new Date().getFullYear() }} PTC Wizard, All rights reserved.</div>
      </small>
    </section>
  </main>
</template>

<style scoped>
.warning{
  color: red;
  font-size: smaller;
}
</style>

<script setup>
import { ref, onMounted } from "vue";
import AuthService from "@/services/auth.service";
import { useSchoolStore } from "@/stores/school";

import Logo from "@/assets/icons/logo-vertical-regular.svg";
import { useRoute, useRouter } from "vue-router";
import { useAuthenticationStore } from "@/stores/authentication";

const router = useRouter();

const loadingState = ref(false);
const wasValidated = ref(false);
const cleartextPass1 = ref(false);
const cleartextPass2 = ref(false);
const password = ref(null);
const password_confirm = ref(null);
const route = useRoute();
const passwordReset = ref(false);
const passwordError = ref(false);
const schoolStore = useSchoolStore();
const authStore = useAuthenticationStore();
const school = ref({});
const errorMsg = ref("");
function clearForm() {
  wasValidated.value = false;
  loadingState.value = false;
  return true;
}

function save() {
  if (password.value != password_confirm.value || password.value == null || password.value == "") {
    wasValidated.value = true;
    loadingState.value = false;

    return false;
  }
  loadingState.value = true;
  var user = {
    password: password.value,
    uid: route.params.uid,
    account: route.params.account,
    authentication_type: "parent"
  };
  AuthService.resetPassword(user).then((response) => {
    loadingState.value = false;
    if (response.status) {
      passwordReset.value = true;
      passwordError.value = false;
      authStore.resetPassword=false;
      if (authStore.isLoggedIn()){
        router.push("/" + route.params.account);

      }
    } else if (response.error) {
      // console.log(response);
      if (schoolStore.school.school_email != null) {
        errorMsg.value =
          "Password can not be reset for this user account at this time.  Please request a passsword reset again or contact your school for help at " +
          schoolStore.school.school_email;
      } else {
        errorMsg.value =
          "Password can not be reset for this user account at this time.  Please request a passsword reset again or contact your school for help";
      }

      passwordReset.value = false;
      passwordError.value = true;
    }
  });
}
onMounted(() => {
  console.log("test");
  if (school.value.school_id) {
    return true;
  } else {
    if (route.params.account != null && route.params.account != "") {
      schoolStore.fetchSchool(route.params.account).then(() => {
        school.value = schoolStore.school;
        console.log("School found");
      });
    } else {
      window.location.href = "https://www.ptcwizard.com";
    }
  }
});
</script>
